import { ActionType } from '../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../core/api/rsaa';
import { Endpoints } from '../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../core/api/module';
import * as R from 'ramda';
import { ParticipantProject } from '../models';


const KEY_ACTION = ActionType.LoadProjectResourcesRequest;
const ACTIONS    = [
  ActionType.LoadProjectResourcesRequest,
  ActionType.LoadProjectResourcesResponse,
  ActionType.LoadProjectResourcesError,
];


type Payload = ParticipantProject;

type Meta = {
  projectId: number,
};


/**
 * Dispatch this action to load an index of project resources (basically, educational content for how to use TruScore
 * for this specific project)
 */
export const loadProjectResourcesAction = (
  projectId: number,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.ProjectResources,
  headers:  { 'content-type': 'application/json' },
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId }),
  body:     state => JSON.stringify({
    projectId:  projectId,
    languageId: state.locale.lang.languageId,
  }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assoc('projectResources', payload, successState);
};


export const loadProjectResourcesReducer = makeApiReducer<Payload>(ACTIONS, KEY_ACTION, reducer);
